import angular from 'angular'
import selectTreeDirective from './selectTreeDirective'

export default angular
    .module('app.selectTree3', [])
    .directive('selectTree3', selectTreeDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/selectTree3/index.js